const viewportUnits = () => {
	document.documentElement.style.setProperty(
		'--vh',
		`${(window.innerHeight * 0.01) / 16}rem`
	);

	document.documentElement.style.setProperty(
		'--vw',
		`${(document.body.clientWidth * 0.01) / 16}rem`
	);

	const header = document.querySelector('.main-header');
	const adminBar = document.getElementById('wpadminbar');
	const footer = document.querySelector('.main-footer');

	const headerHeight = header ? header.offsetHeight : 0;
	const adminBarHeight = adminBar
		? document.querySelector('#wpadminbar').offsetHeight
		: 0;
	const footerHeight = footer ? footer.offsetHeight : 0;

	document.body.style.setProperty(
		'--header-height',
		`${headerHeight + adminBarHeight}px`
	);

	document.body.style.setProperty('--footer-height', `${footerHeight}px`);
};

export default viewportUnits;
